import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { withTranslation } from 'react-i18next'

import { setTopNotificationBlockShown } from 'store/entities/localSettings/actions'
import { isTopNotificationBlockShown } from 'store/entities/localSettings/selectors'
import { setFeatureAsShown } from 'store/entities/identity/actions'
import { isShowFeatureSms, isDesktopNotificationsAvailable } from 'store/entities/identity/selectors'
import Notification from './Notification'

const mapStateToProps = createStructuredSelector({
  isTopNotificationBlockShown,
  isShowFeatureSms,
  isDesktopNotificationsAvailable,
})

const mapDispatchToProps = {
  setTopNotificationBlockShown,
  setFeatureAsShown,
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('user')(Notification))
